<template lang="pug">
.showcase-modal.fadeIn
  .showcase__header
    a(class="slideshow__actions close fa fa-times", @click="close()")
  .showcase__body
    single-flixel(:flixel='flixel', resize='true' class="fadeInDown")
    a.link_overlay(:href="/cinemagraph/+ flixel.hash")
    a.slideshow__actions.prev(@click='prev(slideshowIndex)')
      img(srcset='https://s3.amazonaws.com/flixels/static/static-web/gallery/arrow-left%402x.png 2x, https://s3.amazonaws.com/flixels/static/static-web/gallery/arrow-left.png 1x')
    a.slideshow__actions.next(@click='next(slideshowIndex)')
      img(srcset='https://s3.amazonaws.com/flixels/static/static-web/gallery/arrow-right%402x.png 2x, https://s3.amazonaws.com/flixels/static/static-web/gallery/arrow-right.png 1x')
  .showcase__footer
    .showcase__footer--item
      a.avatar(
        :href='flixel.username',
        v-bind:style="{ backgroundImage: 'url(' + flixel.user_avatar + ')' }",
        v-if='flixel.user_avatar')
      .details
        .h-vertical-align
          p.h-bold
            router-link(:to="{ name: 'Profile', params: { username: flixel.username } }") {{ flixel.username }}
          p(v-if='flixel.caption')
            a(:href="/cinemagraph/ + flixel.hash") {{ flixel.caption | cut(true,50) }}
    .showcase__footer--item
      social-sharing(:flixel='flixel')
</template>

<script>
import SocialSharing from './SocialSharing.vue';
import singleFlixel from './SingleFlixel.vue';
import EventBus from '../eventBus.js';
import CutFilter from '../filters/cut.js';

export default {
  name: 'Slideshow',
  props: ['collection', 'index'],
  data() {
    return {
      slideshowIndex: 0,
      flixel: '',
    };
  },
  filters: {
    // This can be abstracted away into it's own filter file
    cut: function (value, wordwise, max, tail) {
      if (!value) {
        return '';
      }

      max = parseInt(max, 10);
      if (!max) {
        return value;
      }
      if (value.length <= max) {
        return value;
      }

      value = value.substr(0, max);
      if (wordwise) {
        const lastspace = value.lastIndexOf(' ');
        if (lastspace !== -1) {
          value = value.substr(0, lastspace);
        }
      }

      return value + (tail || ' …');
    },
  },
  created() {
    this.flixel = this.collection.data.results[this.index];
    this.slideshowIndex = this.index;
  },
  mounted() {
    const self = this;
    window.addEventListener('keyup', function (event) {
      if (event.keyCode === 27) {
        self.close();
      }
      if (event.keyCode === 37) {
        self.prev(self.slideshowIndex);
      }
      if (event.keyCode === 39) {
        self.next(self.slideshowIndex);
      }
    });
  },
  methods: {
    showSlideshow() {
      this.slideshow.show = !this.slideshow.show;
    },
    close() {
      EventBus.$emit('closeslideshow');
    },
    next(index) {
      const length = this.collection.data.results.length - 1;
      this.slideshowIndex = (index === length) ? 0 : index + 1;
      this.flixel = this.collection.data.results[this.slideshowIndex];
    },
    prev(index) {
      const length = this.collection.data.results.length - 1;
      this.slideshowIndex = (index === 0) ? length : index - 1;
      this.flixel = this.collection.data.results[this.slideshowIndex];
    },
  },
  components: {
    'singleFlixel': singleFlixel,
    'social-sharing': SocialSharing,
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Slideshow.vue